module.exports = __webpack_public_path__ + "static/media/ISO22000.d4efbacd.png";